/** Id del canal en UI / dominio (minúsculas). */
export type ProductVisibilityChannelId = 'public_catalog' | 'pos';
export type ProductVisibilityBooleanField = 'publicVisible' | 'posVisible';

export interface ProductVisibilityChannelConfig {
  id: ProductVisibilityChannelId;
  /** Valor del enum GraphQL `ProductVisibilityChannel`. */
  graphql: string;
  labelKey: string;
  /** Propiedad del modelo usada por el fallback de filtrado en cliente. */
  productField: ProductVisibilityBooleanField;
}

/**
 * Registro de canales de visibilidad. Al agregar un canal: columna en BD, enum GraphQL y entrada aquí.
 */
export const PRODUCT_VISIBILITY_CHANNELS: ReadonlyArray<ProductVisibilityChannelConfig> = [
  {
    id: 'public_catalog',
    graphql: 'PUBLIC_CATALOG',
    labelKey: 'catalog.products.visibilityFilter.publicCatalog',
    productField: 'publicVisible',
  },
  {
    id: 'pos',
    graphql: 'POS',
    labelKey: 'catalog.products.visibilityFilter.pos',
    productField: 'posVisible',
  },
];

export function toGraphqlVisibleInChannels(channelIds?: string[] | null): string[] | null {
  if (!channelIds?.length) {
    return null;
  }
  const mapped = channelIds
    .map((id) => PRODUCT_VISIBILITY_CHANNELS.find((c) => c.id === id)?.graphql)
    .filter((value): value is string => Boolean(value));
  return mapped.length ? mapped : null;
}

export function toGraphqlProductStructureFilter(
  structure?: 'simple' | 'variable' | null
): 'SIMPLE' | 'VARIABLE' | null {
  if (!structure) {
    return null;
  }
  return structure === 'variable' ? 'VARIABLE' : 'SIMPLE';
}
